<template>
  <div class="mc-modal" id="bestPrice" :class="{isOpen: isOpen}">
    <div class="mc-modal__outer">
      <div class="mc-modal__inner">
        <div class="mc-modal__heading">
          <button @click="$emit('close')" class="mc-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
            <svg class="mc-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
              <use xlink:href="/assets/svg/sprite.svg#icon-cross"></use>
            </svg>
          </button>
          <div class="mc-modal__title">
            Получить лучшую цену
          </div>
        </div>
        <div class="mc-modal__body">
          <div class="mc-modal__content mc-modal__content--centered">
            Нашли дешевле? Получите скидку. Отправьте нам скриншот и ссылку на почту <a href="mailto:info@mcbuy.ru">info@mcbuy.ru</a>
          </div>
        </div>
        <div class="mc-modal__bottom">
          <router-link to="/page/discount-terms/" class="mc-button simulated-hover" type="button">
                            <span class="mc-button__text">
                                Подробности
                            </span>
          </router-link>
          <button @click="$emit('close')" class="mc-button mc-button--color js-button-close simulated-hover" type="button">
                            <span class="mc-button__text">
                                Закрыть
                            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: false
  },
  emits: ['close']
}
</script>